<template>
    <div class="chart-container">
        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables);

export default{
    props: { data: { type: Array, default: () => [] } },
    setup(props){
        const chartCanvas = ref(null);
        let chartInstance = null;

        const createChart = () => {
            if (!props.data.length || !props.data[0]?.length) {
                return;
            }

            if (chartInstance) chartInstance.destroy();
            chartInstance = new Chart(chartCanvas.value, {
                type: 'line',
                data:{
                    labels: props.data.length ? props.data[0].map(item => item.x) : [],
                    datasets:[
                        {
                            label: 'VISTORIAS',
                            data: props.data[0].map(item => item.y),
                            borderColor: '#1a4c4c',
                            fill: false,
                        },
                        {
                            label: 'NC',
                            data: props.data[1].map(item => item.y),
                            borderColor: '#FF6384',
                            fill: false,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    resizeDelay: 200,
                    
                    scales: {
                        x: {
                            type: 'category',
                            title: { display: false, text: 'Mês' },
                        },
                        y: {
                            title: { display: true, text: 'Quantidade' },
                        },
                    },
                    plugins:{
                        legend:{
                            onClick: null,
                        },
                    },
                },
            });
        }

        onMounted(createChart);

        watch(
            () => props.data,
            createChart
        )

        return{ chartCanvas };
    }
}
</script>

<style scoped>
.chart-container {
    width: 100%;
    max-width: 600px;
    height: 300px;
    margin: 0 auto;
    border-radius: 8px;
    border: 3px solid #a6a6a6;
    box-sizing: border-box;
    position: relative;
}

canvas {
    display: block;
}
</style>